// Discount helpers for product pricing display.
export function getPricing(product) {
  const price = Number(product?.price_from || 0);
  const sale = product?.sale_price != null ? Number(product.sale_price) : null;
  const onSale = sale != null && sale > 0 && price > 0 && sale < price;
  const currency = product?.currency || "₪";
  const percent = onSale ? Math.round(((price - sale) / price) * 100) : 0;
  const fmt = (n) => (n ? `${n.toLocaleString("en-US", { maximumFractionDigits: 0 })} ${currency}` : "");
  const outOfStock = product?.in_stock === false;
  return {
    onSale,
    currency,
    percent,
    priceStr: price ? fmt(price) : "بحسب المشروع",
    saleStr: onSale ? fmt(sale) : "",
    rawPrice: price,
    rawSale: sale,
    outOfStock,
  };
}
